import { BaseEdge, type EdgeProps, getBezierPath } from '@xyflow/react';

/**
 * Custom bezier edge component for attack path visualization.
 *
 * Provides smooth curved edges with 2px stroke width.
 */
export function CustomBezierEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  // Destructure React Flow internal props to prevent them from being spread to DOM
  // These props cause React warnings when passed to SVG elements
  selectable: _selectable,
  deletable: _deletable,
  sourceHandleId: _sourceHandleId,
  targetHandleId: _targetHandleId,
  pathOptions: _pathOptions,
  interactionWidth: _interactionWidth,
  ...rest
}: EdgeProps) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    curvature: 0.15,
  });

  return (
    <BaseEdge
      path={edgePath}
      markerEnd={markerEnd}
      style={{
        ...style,
        strokeWidth: 2,
      }}
      {...rest}
    />
  );
}
